/**
 * @generated SignedSource<<d99f9a40c11aa8b3a81c9f2b13bbcd03>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MeetingsGroupEventsQuery$variables = {
  end?: string | null;
  start?: string | null;
};
export type MeetingsGroupEventsQuery$data = {
  readonly dayEvents: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly end: string | null;
        readonly guid: string;
        readonly id: string;
        readonly note: {
          readonly stream: {
            readonly latestNoteEditedAt: string | null;
            readonly viewerLastSeenAt: string | null;
          };
        } | null;
        readonly start: string | null;
        readonly title: string;
        readonly " $fragmentSpreads": FragmentRefs<"MeetingLink_meeting">;
      };
    } | null>;
  };
};
export type MeetingsGroupEventsQuery = {
  response: MeetingsGroupEventsQuery$data;
  variables: MeetingsGroupEventsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "end"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "start"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "start",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "end",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "guid",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerLastSeenAt",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "latestNoteEditedAt",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v11 = [
  {
    "kind": "Variable",
    "name": "end",
    "variableName": "end"
  },
  {
    "kind": "Variable",
    "name": "start",
    "variableName": "start"
  }
],
v12 = [
  (v1/*: any*/)
],
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MeetingsGroupEventsQuery",
    "selections": [
      {
        "alias": "dayEvents",
        "args": null,
        "concreteType": "EventConnection",
        "kind": "LinkedField",
        "name": "__HomePanel_dayEvents_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "EventEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Event",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Note",
                    "kind": "LinkedField",
                    "name": "note",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "NoteStream",
                        "kind": "LinkedField",
                        "name": "stream",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v7/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "MeetingLink_meeting"
                  },
                  (v8/*: any*/)
                ],
                "storageKey": null
              },
              (v9/*: any*/)
            ],
            "storageKey": null
          },
          (v10/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MeetingsGroupEventsQuery",
    "selections": [
      {
        "alias": "dayEvents",
        "args": (v11/*: any*/),
        "concreteType": "EventConnection",
        "kind": "LinkedField",
        "name": "eventsByUserEventFilters",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "EventEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Event",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Note",
                    "kind": "LinkedField",
                    "name": "note",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "NoteStream",
                        "kind": "LinkedField",
                        "name": "stream",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v7/*: any*/),
                          (v1/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "HomePanelGroup",
                            "kind": "LinkedField",
                            "name": "homePanelGroup",
                            "plural": false,
                            "selections": (v12/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasExternalUsersOrHasRelatedExternalStreams",
                            "storageKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v8/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "HomePanelGroup",
                                "kind": "LinkedField",
                                "name": "homePanelGroup",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "name",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v13/*: any*/)
                                ],
                                "type": "NoteStream",
                                "abstractKey": null
                              }
                            ],
                            "type": "HomePanelObjectInterface",
                            "abstractKey": "__isHomePanelObjectInterface"
                          }
                        ],
                        "storageKey": null
                      },
                      (v1/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "finished",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isHidden",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isOrganizer",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isAllDay",
                    "storageKey": null
                  },
                  (v13/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Calendar",
                    "kind": "LinkedField",
                    "name": "calendar",
                    "plural": false,
                    "selections": (v12/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "willBeRecorded",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "status",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "timeBlockType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ConferenceCall",
                    "kind": "LinkedField",
                    "name": "conferenceCalls",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "provider",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "url",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v8/*: any*/)
                ],
                "storageKey": null
              },
              (v9/*: any*/)
            ],
            "storageKey": null
          },
          (v10/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "dayEvents",
        "args": (v11/*: any*/),
        "filters": [],
        "handle": "connection",
        "key": "HomePanel_dayEvents",
        "kind": "LinkedHandle",
        "name": "eventsByUserEventFilters"
      }
    ]
  },
  "params": {
    "cacheID": "99337c5ef2d96953c1d59731453af2eb",
    "id": null,
    "metadata": {
      "connection": [
        {
          "count": null,
          "cursor": null,
          "direction": "forward",
          "path": [
            "dayEvents"
          ]
        }
      ]
    },
    "name": "MeetingsGroupEventsQuery",
    "operationKind": "query",
    "text": "query MeetingsGroupEventsQuery(\n  $end: DateTime\n  $start: DateTime\n) {\n  dayEvents: eventsByUserEventFilters(start: $start, end: $end) {\n    edges {\n      node {\n        id\n        start\n        end\n        title\n        guid\n        note {\n          stream {\n            viewerLastSeenAt\n            latestNoteEditedAt\n            id\n          }\n          id\n        }\n        ...MeetingLink_meeting\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment GroupsMenu_stream on NoteStream {\n  ...HomePanelGroupsMenu_object\n  id\n  homePanelGroup {\n    id\n  }\n}\n\nfragment HomePanelGroupsMenu_object on HomePanelObjectInterface {\n  __isHomePanelObjectInterface: __typename\n  id\n  __typename\n  ... on NoteStream {\n    type\n  }\n  homePanelGroup {\n    id\n    name\n  }\n}\n\nfragment MeetingLink_meeting on Event {\n  id\n  title\n  guid\n  isHidden\n  isOrganizer\n  start\n  end\n  isAllDay\n  note {\n    finished\n    stream {\n      ...GroupsMenu_stream\n      id\n      viewerLastSeenAt\n      latestNoteEditedAt\n      hasExternalUsersOrHasRelatedExternalStreams\n    }\n    id\n  }\n  type\n  calendar {\n    id\n  }\n  ...RecordIcon_event\n}\n\nfragment RecordIcon_event on Event {\n  id\n  guid\n  willBeRecorded\n  start\n  status\n  isAllDay\n  timeBlockType\n  conferenceCalls {\n    provider\n    url\n  }\n  calendar {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "b9affdd56717418e2614749a7bc39509";

export default node;
